import { DictionaryStatusesEnum } from '../enums/DictionaryStatusesEnum';

export function hasDictionaryFailedDeep(value: unknown): boolean {
  if (!value) {
    return false;
  }
  if (value === DictionaryStatusesEnum.FAILED) {
    return true;
  }
  if (typeof value !== 'object') {
    return false;
  }
  if (
    value &&
    'status' in value &&
    (value as { status: DictionaryStatusesEnum }).status === DictionaryStatusesEnum.FAILED
  ) {
    return true;
  }
  if (Array.isArray(value)) {
    return value.some(hasDictionaryFailedDeep);
  }
  if (Object.keys(value as object).length === 0) {
    return false;
  }

  return Object.values(value as Record<string, unknown>).some(hasDictionaryFailedDeep);
}
